export default class globalVar {
  static version = 1001
  static state = 'live' //live / test
  static mode = 'lite' //normal / lite
}
